/**
 * @todo Удалить директорию с экспериментом
 * @description Данный функционал появился в задаче CD-153172, будет удалён в задаче CD-153173
 * Если эксперимент будет удачным, то оставить строку, но удалить комментарий,
 * если эксперимент будет не удачным, то удалить полностью строку
 */

import { ArticleHeading4, CianSmall16, Label, Tooltip, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './UniqueForCianBadge.css';

export const UniqueForCianBadge: React.FC = () => (
  <Tooltip
    placement="bottom"
    theme="white"
    title={
      <div className={styles['content']}>
        <ArticleHeading4>Только на Циан</ArticleHeading4>
        <UIText2>
          За последние сутки мы не нашли этот объект
          <br />в открытом доступе на других агрегаторах
        </UIText2>
      </div>
    }
  >
    <Label background="primary_10" color="primary_100" icon={<CianSmall16 color="primary_100" />}>
      Только на Циан
    </Label>
  </Tooltip>
);

UniqueForCianBadge.displayName = 'UniqueForCianBadge';
